<template>
	<div id="Reallygood">
		<!--头部-->
	 	<mt-header :title='tName'  fixed class="reallygoodheader">
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
			    <mt-button icon="back" class="font-Yahei"></mt-button>
		   </a>
		</mt-header>
		
		<!--轮播框-->
		<div class="reallyswipewrap" v-if="products!=''"> <!--判断数组不为空再显示-->
			<swiper :options="swiperOption" ref="mySwiper">
			 <swiper-slide v-for="(value,key,index) in (products[currentIndex].pics)" :key="index">
			 	<img :src="urlPrefixImg+'/'+value" :alt="key"/>
			 </swiper-slide>
			 <div class="swiper-pagination "  slot="pagination"></div>
			</swiper>
		</div>
		<!--<p>{{currentIndex}}</p>-->
		<!--规格选择-->
		<div class="border-bottom-line" >
		 	 <div class="faceValueBoxgood">
		 	 	<p class="raallygoodtitlep">规格</p>
		 	 	<ul class="reallyfaceValue">
		 	 	 <li v-for="(item,index) in products" :class="{mr0:(index+1) % 3==0,active:currentIndex==index}" @click="payTypes(index)">
		 	 	 	<p class="font-size9 qcoins"><strong>{{item.proName.split(' ')[0]}}</strong></p>
		 	 	 	<p class="font-size8 element">{{item.proName.split(' ')[item.proName.split(' ').length-1]}}</p>
		 	 	 </li>
		 	 	</ul>
		 	 </div>     
	 	</div>
	 	<!--{{proName}}-->
	 	<!--数量选择-->
	 	<div class="numbox border-bottom-line">
	 	<mt-field label="数量" placeholder="请输入数量" type="number" v-model="inputmessage" v-on:input="checkNum"></mt-field>
	 	<!--<p>Message is: {{ inputmessage*200 }}</p>-->
	 	</div>
	 	
	 	<!--立即购买-->
	 	<div class="bgcontent">
	 		<div class="purchasegood ">
		 		<div class="clearfix">
			 	    <dl class="purchase">
				 	   	 <dt>
				 	   	 	<!--products[this.currentIndex].price-->
				 	   	 	<!--products[this.currentIndex].payInfo.price-->
				 	   	 	<!--{{inputmessage ==='' ? products[this.currentIndex].price : products[this.currentIndex].price}}-->
				 	   	 	<!--{{inputmessage ==='' ? products[this.currentIndex].payInfo.price : products[this.currentIndex].payInfo.price}}-->
				 	   	 	<p class="colorff8900 font-size10" v-if="goodsPrice!=''"><strong>{{totalPrice}}元</strong></p>
				 	   	 	<!--<p class="colorff5513 font-size8" v-if="goodsvPrice!=''">{{goodsvPrice}}V</p>-->
				 	   	 </dt>
				 	   	 <dd><mt-button type="primary" size="small" class="font-Yahei btnbuy" @click="reallybuyNow">立即购买</mt-button></dd>
			 	   	</dl> 
		 	   	</div>
		 	   	 <!--<div>
		 	   	      <p class="font-size8 color999" v-if="products!=''">{{products[this.currentIndex].payInfo.body}}<label></label></p>
		 	   	 </div>-->
	 	    </div>
	 	</div>
	 	
	 	<!--商品介绍-->
	 	<div class="bgcontent">
	 		<div class="purchasegood">
	 			<div class="gooddescript font-size8" v-html="descript"> 				
	 			</div>
	 		</div>
	 	</div>
	 	<!--白条-->
	 	<div class="whtiebar"></div>
	</div>
</template>

<script>
	import { Toast } from 'mint-ui'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	import { Indicator } from 'mint-ui'
	export default{
		components:{
			swiper,  
            swiperSlide
		},
		data(){
			return{
				swiperOption: {   //轮播参数
		          setWrapperSize :true,
		          loop: true,
		          pagination : '.swiper-pagination',
		          paginationClickable :true,
		          mousewheelControl : true,
		          autoplayDisableOnInteraction: false,
		          observeParents:true,
//		          paginationType: 'custom',
                  paginationType: 'fraction',
			    },
			   inputmessage:1, //数量输入框默认参数
			   tName:'',   //头部商品名称
			   descript:'',  //商品描述
			   currentIndex:0, //规格框默认选择值
			   products:[], //商品规格数组
               paytype:"",  //支付类型信息
			   tid:localStorage.getItem("tid"), //获取二级分类ID 17
			   ttype:localStorage.getItem("ttype"),  //获取商品分类  0
               //ttype:0,  //商品分类  0
			   faceId:localStorage.getItem("faceId"),
			   urlPrefixImg:this.URL_PREFIX_IMG, //图片地址
			   proName:'', //规格选中时的名称
			   goodsPrice:'', //人民币价格
//			   goodsvPrice:'', //V币价格
			   topImg:'', //实物订单图标
			   paysType:[], //获取支付方式
			   freight:{},  //运费
			   pid:"",
			   priceNum:'',
			   maxNum:'',
			   totalPrice:""
			}
		},
		created:function(){
		  this.getgoodsmessage(); //执行实物数据获取函数
		},
		methods: {
			//返回按钮
			returnBack(){
				this.$router.push('/');
			},
			 //数量金额
		     checkNum(){
		     	if(this.inputmessage<0||this.inputmessage==""){
						this.totalPrice=this.priceNum;
					}else if(this.inputmessage>this.maxNum){
						this.inputmessage = 1;
						Toast("购买数量最多为"+this.maxNum);
					}else{
					    this.totalPrice=(this.priceNum*this.inputmessage).toFixed(2);
					}
		     },
            //确定规格点击下标
            payTypes(i){  
	     	this.currentIndex=i;  //选中下标变量
	     	this.proName=this.products[i].proName; //选中规格的名称和属性
	     	this.goodsPrice=this.products[i].price; //人民币价格
	     	this.totalPrice=this.goodsPrice;
	     	this.priceNum=this.products[i].price;
//	     	this.goodsvPrice=this.products[i].payInfo.price; //V币价格
	     	this.paysType=this.products[i].payType;//获取支付方式
//	     	console.log(this.products[i].payType);
	     	this.freight=this.products[i].freight; //商品运费
	     	this.pid=this.products[i].pid; //商品的pid
	     	},
	     	//立即购买
	     	reallybuyNow(){
	     		localStorage.setItem("orderIdflag",'');//订单列表返回标志
	     		localStorage.setItem("price",this.goodsPrice); //保存人民币价格
	     		localStorage.setItem("ttype", 0);
		     	//localStorage.setItem("goodsvPrice0",this.goodsvPrice); //保存V币价格
	     		localStorage.setItem("tName",this.tName); //保存头部名称
		     	localStorage.setItem("proName",this.proName); //保存规格选中时的名称和属性
		     	localStorage.setItem("pid",this.pid); //实物商品的pid
		     	var freightR=this.freight.R; //定义人民币的运费
		     	var freightV=this.freight.V; //定义V币的运费
		     	localStorage.setItem("freightR",freightR);  //保存人民币的运费
		     	localStorage.setItem("freightV",freightV);  //保存V币的运费
		     	localStorage.setItem("pic",this.topImg);  //保存实物订单图标
		     	var obj=JSON.stringify(this.paysType);  
	     	    localStorage.setItem("payType",obj);  //保存支付方式
	     	    localStorage.setItem("num",this.inputmessage);//数量
	     	    var totalPrice0=(this.goodsPrice*this.inputmessage+parseFloat(freightR)).toFixed(2); //总人民币
	     	    var totalPriceOb=(this.goodsPrice*this.inputmessage).toFixed(2); //总人民币,不加运费
	     	    //var totalvPrice0=this.goodsvPrice*this.goodsvPrice+freightV; //总V币
	     	    localStorage.setItem("totalPrice",totalPrice0); //保存总人民币价格
	     	    localStorage.setItem("totalPriceOb",totalPriceOb); //保存总人民币价格，不加运费
		     	//localStorage.setItem("totalvPrice0",totalvPrice0); //保存总V币价格
				 if(this.ReallygoodNum()){
					this.$router.push({path: '/Order/index'});
				 }
	     		
//	     		this.$router.push({path: "/Login"});
	     	},
	     	 //数量验证
	     	ReallygoodNum(){
	     	   var reg=/^\+?[1-9]\d*$/;
	     	   if(this.inputmessage==""){
	     	   	  Toast("请输入正确的购买数量");
	              return false;
	     	   }else if(!reg.test(this.inputmessage)){
	     	   	  Toast("输入数量格式有误,请输入整数");
	              return false;
	     	   }else if(this.inputmessage<0){
	     	   	  Toast("购买数量最少1张");
	     	   	  this.inputmessage=1;
	              return false;
	     	   }else{
	     	   	  return true;
	     	   }
	     	},
	     	
	     	//获取实物信息函数
	     	getgoodsmessage(){
	     		Indicator.open();
	     		this.$http.post(this.URL_PREFIX+"/category/findCategoryTypeById.net",{tid:this.tid,proType:this.ttype})
			  	.then((res) =>{
			  		Indicator.close();
                    this.maxNum=res.data.obj.proType[0].size;//商品一次购买最大数量
			  		this.tName=res.data.obj.tName; //头部商品名称
			  		this.descript=res.data.obj.proIntroduce; //商品描述
			  		this.products=res.data.obj.products; //商品规格数组
			  		this.topImg=res.data.obj.proTImg; //订单图标
			  		this.payTypes(0);//执行一次下标改变函数
			   });
	     	}
		}
	}
</script>

<style scoped="scoped">
	@import "../../../static/css/swiper.min.css";
	#Reallygood .reallygoodswipe img{
		width: 100%;
	}
	#Reallygood .reallyswipewrap{
		margin-top: 40px;
		position: relative;
	}
	/*#Reallygood .reallygoodheader{
		background: orange;
	}*/
	#Reallygood .reallyswipeitem{
		position: absolute;
		width: 50px;
		height: 20px;
		background-color: rgba(102, 102, 102, 0.7);
		border-radius: 12px;
		opacity: 0.7;
		bottom: 10px;
		right: 10px;
		/*padding: 8px 24px 9px 25px;*/
		text-align: center;
		line-height: 20px;
		box-sizing: border-box;
		font-family: PingFang-SC-Regular;
	    font-size: 0.5rem;
	    z-index: 2;
	    color: #ffffff;
	}
	#Reallygood .reallyfaceValue li{
		float: left;
	    border: 1px solid #ff8900;
	    color: #ff8900;
	    border-radius: 5px;
	    -webkit-border-radius: 5px;
	    text-align: center;
	    width: 30%;
	    padding: 2px 0;
	    margin: 0 4% 4% 0;
	    /*height: 60px;*/
	    /*display: flex;*/
	    /*justify-content: center;*/
	    /*align-items: center;*/
	}
	#Reallygood .raallygoodtitlep{
		margin-bottom: 8px;
		font-size: 0.8rem;
		color: #666666;
	}
	#Reallygood .reallyfaceValue .mr0{
		margin-right: 0;
	}
	#Reallygood .faceValueBoxgood{
	    width: 95%;
	    margin: 0 auto;
	    padding: 15px 0 5px 0;
	    overflow: hidden;
	}
	#Reallygood .purchasegood{
	    padding: 20px 15px;
	    border-bottom: 1px solid #e0e0e0;
	    overflow: hidden;
	}
	#Reallygood .mint-cell-wrapper {
	    padding: 0;
	    font-size: 14px;
	    color: #333;
	    background-image: none;
    }
    #Reallygood .mint-cell-title{margin-left:15px;}
    #Reallygood .mint-cell-value{margin-right:15px;}
    #Reallygood .purchasegood dt {
	    width: 65%;
	    float: left;
	    line-height: 23px;
	    margin-top: 6px;
    }
    #Reallygood .purchasegood dd {
	    float: right;
	    /*margin-top: 3%;*/
	}
	#Reallygood .mint-button--primary {
	    background: #ff8920;
	}
	#Reallygood .mint-header.is-fixed {
    top: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 5;
    }
    #Reallygood .swiper-pagination-fraction{
    	left: 80%;
    	position: absolute;
		width: 50px;
		height: 20px;
		background-color: rgba(102, 102, 102, 0.7);
		border-radius: 12px;
		opacity: 0.7;
		bottom: 10px;
		/*right: 10px;*/
		/*padding: 8px 24px 9px 25px;*/
		text-align: center;
		line-height: 20px;
		box-sizing: border-box;
		font-family: PingFang-SC-Regular;
	    font-size: 0.5rem;
	    z-index: 2;
	    color: #ffffff;
    }
    #Reallygood .gooddescript{
	    margin: 0 auto;
	    color: #999;
	    font-size: 0.8rem;
	    line-height: 20px;
    }
 #Reallygood .reallyfaceValue li.active{background: #ff8920;color: #fff;border:1px solid #ff8920;}
 #Reallygood .reallyfaceValue li.active p{color: #fff;}
 #Reallygood .reallyfaceValue li.mr0{margin-right: 0;}
 .whtiebar{
 	width: 100%;
 	height: 100px;
 }
</style>


// WEBPACK FOOTER //
// src/views/Details/Reallygood.vue